import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Iter 629 (founder) — wallet tabs: keep "My coins" and "Buy points" as two
 * clearly separate tabs instead of mixing the buy CTA into the coins card.
 * Rendered under the wallet header on /rewards, /points/buy and
 * /points/history; navigation replaces so the tabs don't stack history.
 */
const TABS = [
  { key: "coins", label: "🪙 My coins", route: "/rewards" },
  { key: "buy", label: "💳 Buy points", route: "/points/buy" },
  { key: "history", label: "🧾 History", route: "/points/history" },
];

export default function WalletTabs({ active }) {
  const nav = useNavigate();
  const { pathname } = useLocation();
  return (
    <div
      className="flex rounded-xl bg-slate-100 p-1 gap-1 w-full max-w-md"
      data-testid="wallet-tabs"
      role="tablist"
    >
      {TABS.map((t) => {
        const on = t.key === active;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={on}
            data-testid={`wallet-tab-${t.key}`}
            onClick={() => {
              if (pathname !== t.route) nav(t.route, { replace: true });
            }}
            className={`flex-1 min-h-[44px] rounded-lg text-[13.5px] transition-colors ${
              on
                ? "bg-white shadow-sm font-black text-[#0F70A8]"
                : "font-bold text-slate-500 hover:text-slate-700"
            }`}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
